/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AtoNDefinition } from './AtoNDefinition';
import {
    AtoNDefinitionFromJSON,
    AtoNDefinitionFromJSONTyped,
    AtoNDefinitionToJSON,
} from './AtoNDefinition';

/**
 * 
 * @export
 * @interface GetAtoNs200Response
 */
export interface GetAtoNs200Response {
    /**
     * 
     * @type {Array<AtoNDefinition>}
     * @memberof GetAtoNs200Response
     */
    records?: Array<AtoNDefinition>;
}

/**
 * Check if a given object implements the GetAtoNs200Response interface.
 */
export function instanceOfGetAtoNs200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetAtoNs200ResponseFromJSON(json: any): GetAtoNs200Response {
    return GetAtoNs200ResponseFromJSONTyped(json, false);
}

export function GetAtoNs200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAtoNs200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(AtoNDefinitionFromJSON)),
    };
}

export function GetAtoNs200ResponseToJSON(value?: GetAtoNs200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(AtoNDefinitionToJSON)),
    };
}

